import Trends from './Trends';
import { useParams } from 'react-router-dom';
import { getbookMarkByname } from './ChartCalls';
import React, { Fragment, useEffect, useState } from 'react';

let ViewTrends = () => {
  let { id } = useParams();
  let [trendData, setTrendData] = useState([]);
  useEffect(() => {
    let fetchData = async () => {
      try {
        let data = await getbookMarkByname(id);
        if (data && data[0]) {
          let tunedData = data[0].Payload;
          setTrendData(tunedData);
        }
      } catch (error) {
        console.error("Error Fetching data :", error);
      }
    };
    fetchData();
  }, [id]);

  return (
    <Fragment>
      <Trends tunedData={trendData} />
    </Fragment>
  );
};

export default ViewTrends;